<template>
  <div>
    <div class="not-found">
      <img src="../assets/404.jpg" :alt="t.notFound">
      <h3>{{t.notFound}}</h3>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    // t is LANGUAGE object
    ...mapGetters(["t"])
  }
};
</script>

<style lang="scss" scoped>
.not-found {
  background: #fff;
  text-align: center;
  padding: 20px;
  h3 {
    margin: 0;
    padding: 20px 0;
    font-size: 14px;
    font-weight: normal;
    color: #333;
  }
  img {
    max-width: 600px;
    width: 100%;
  }
}
</style>
